import { GettingStartedStoreAccess } from "../../store";

export const useCheckIfThemeIsValid = () => {
  const { setIsThemeValid, validateTheme } = GettingStartedStoreAccess.useActions();

  const checkIfThemeIsValid = async (themeId: string) => {
    if (!themeId) {
      return;
    }

    const isValid = await validateTheme(themeId, "templates/product.json");

    setIsThemeValid(isValid);
  };

  return { checkIfThemeIsValid };
};
